import React from 'react';
import FooterBorder from './Border';
import FooterColumn from './Column';
import FooterLinkList from './LinkList';
import LinkListSecondary from './LinkListSecondary';
import FooterLogo from './Logo';
import FooterRow from './Row';

import './style.scss';

interface Props {
  children: React.ReactNode;
}

type FooterComponent = React.FC<Props> & {
  Row: typeof FooterRow;
  Column: typeof FooterColumn;
  LinkList: typeof FooterLinkList;
  LinkListSecondary: typeof LinkListSecondary;
  Logo: typeof FooterLogo;
  Border: typeof FooterBorder;
};

const Footer: FooterComponent = (props) => {
  const { children } = props;

  return (
    <footer className="Footer">
      {children}
    </footer>
  );
};

Footer.Row = FooterRow;
Footer.Column = FooterColumn;
Footer.LinkList = FooterLinkList;
Footer.Logo = FooterLogo;
Footer.LinkListSecondary = LinkListSecondary;
Footer.Border = FooterBorder;

export default Footer;
